import {Injectable} from '@angular/core';
import { Message } from '../class/message';
import { CommonService } from './common.service';
import { ContractService } from './contract.service';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from './api.service';
import {catchError, map} from 'rxjs/operators';
import {of, throwError} from 'rxjs';
import * as firebase from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';

const routes = {
    linkAccout: '/users/reference-account-with-google',
    checkLinkedAccount: '/users/reference-account-with-google/get-email',
    deleteLinkAccount: '/users/delete-reference-account-with-google',
    validatePassword: '/users/validate-password',
    appParam: '/common/app-param',
    connectAccount: '/connect-account',
    disconnectAccount: '/connect-account/delete',
    allLink: '/connect-account/getAll',
    loginZalo: '/auth/login-with-zalo',
}
@Injectable({
  providedIn: 'root'
})

export class LinkAccountService {
    constructor(
        private apiService: ApiService,
        private toastr: ToastrService,
        private contractService: ContractService,
        private commonService: CommonService,
        public message: Message,
        private afAuth: AngularFireAuth,
    ){

    }

    linkAccoutGoogle(body: any) {
        return this.apiService.post(routes.linkAccout, body).pipe(map(res => {
          return res;
        }));
    }

    getGoogleInfo(data: any){
        return this.apiService.post(routes.appParam, data).pipe(map(res => {
          return res;
        }));
    }

    checkLinkedAccount(){
        return this.apiService.get(routes.checkLinkedAccount).pipe(map(res => {
          return res;
        }));
    }

    deleteLinkAccount(){
        return this.apiService.get(routes.deleteLinkAccount).pipe(map(res => {
          return res;
        }));
    }

    validatePassword(password: any){
        return this.apiService.post(routes.validatePassword, password).pipe(map(res => {
          return res;
        }));
    }

    linkAccountZalo(body: any) {
        return this.apiService.post(routes.connectAccount, body).pipe(map(res => {
          return res;
        }));
    }

    unlinkAccountZalo(param: any) {
      return this.apiService.postWithParams(routes.disconnectAccount, param).pipe(map(res => {
        return res;
      }));
    }

    //Login with firebase
    loginWithGoogle() {
      const provider = new firebase.auth.GoogleAuthProvider();
      provider.setCustomParameters({ prompt: 'select_account' });
      return this.afAuth.auth.signInWithPopup(provider);
    }

    loginWithFacebook() {
      const provider = new firebase.auth.FacebookAuthProvider();
      return this.afAuth.auth.signInWithPopup(provider);
    }

    loginWithApple() {
      const provider = new firebase.auth.OAuthProvider('apple.com');
      return this.afAuth.auth.signInWithPopup(provider);
    }

    logoutFirebase() {
      return this.afAuth.auth.signOut();
    }

    //End login with firebase

    //Connect with firebase
    connectWithFireBase(body: any){
      return this.apiService.post(routes.connectAccount, body).pipe(map(res => {
        return res;
      }));
    }

    deleteConnectWithFireBase(body: any){
      return this.apiService.get(routes.disconnectAccount + `?type=${body}`).pipe(map(res => {
        return res;
      }));
    }
    //End connect with firebase

    getAllLink() {
      return this.apiService.get(routes.allLink).pipe(map(res => {
        return res;
      }));
    }
}
